var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.urlValid)?_c('a',{attrs:{"href":_vm.urlWithToken,"download":_vm.name}},[_vm._t("default",[_vm._v(_vm._s(_vm.name))])],2):_c('span',{staticStyle:{"cursor":"not-allowed","color":"#c2c2c2"}},[_vm._t("default",[_vm._v(_vm._s(_vm.name))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }